<template>
    <QuestionnaireQuestion
        v-for="(question, index) in data.questions"
        :key="index"
        :question="question"
        :step-index="stepIndex"
        :step-title="stepTitle"
        :focus="index === 0"
    />
</template>

<script setup lang="ts">
import type { QuestionnaireStepContentQuestionsFragment } from '@/graphql/api'

import QuestionnaireQuestion from '@/components/cms/component/questionnaire/question/QuestionnaireQuestion.vue'

defineProps<{
    data: QuestionnaireStepContentQuestionsFragment
    stepIndex: number
    stepTitle: string
}>()
</script>
